import React, { cloneElement } from 'react';
import { List, Filter, Datagrid, TextInput, TextField, TopToolbar, CreateButton, ExportButton, useListContext, sanitizeListRestProps } from 'react-admin';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import CircleIcon from '@material-ui/icons/FiberManualRecord';

const ActionButtons = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    const {
        resource,
        displayedFilters,
        filterValues,
        basePath,
        showFilter,
        record,
    } = useListContext();

    return (
        <TopToolbar className="mb-3" {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            <CreateButton basePath={basePath} record={record} />
            <ExportButton />
        </TopToolbar>
    );
}


const UserFilter = (props) => (
    <Filter {...props}>
        <TextInput className="pt-1" label={<h6 className="px-2 small rounded" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>Name</h6>} source="display_name" fullWidth variant="outlined" alwaysOn />
        <TextInput className="pt-1" label={<h6 className="px-2 small rounded" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>Email</h6>} source="email" fullWidth variant="outlined" />
    </Filter>
);

const StatusTextFieldUserAccess = ({ className, record, source }) => (
    <span className={(record.access.user) ? 'text-success ' + className : 'text-danger ' + className}>{(record.access.user) ? <CheckIcon /> : <ClearIcon />}</span>
)

const StatusTextFieldAdminAccess = ({ className, record, source }) => (
    <span className={(record.access.admin) ? 'text-success ' + className : 'text-danger ' + className}>{(record.access.admin) ? <CheckIcon /> : <ClearIcon />}</span>
)

const StatusTextField = ({ className, record, source }) => (
    <span className={(record[source]) ? 'text-success ' + className : 'text-danger ' + className}><CircleIcon /></span>
)

export const UserList = props => (
    <>
        <h3 className="text-danger px-3 px-md-0 pt-3 pt-md-0" style={{ fontFamily: 'Arial, sans-serif' }}>Users</h3>
        <List {...props} title=" " filters={<UserFilter />} bulkActionButtons={false} actions={<ActionButtons />}>
            <Datagrid rowClick="show" className="table table-sm table-hover table-borderless">
                <TextField source="display_name" className="px-3 text-capitalize" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Name </h6>} />
                <TextField source="email" className="px-3 text-lowercase" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Email </h6>} />
                <StatusTextFieldUserAccess className="px-3" record={{ ...props }} source="access.user" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>User Access </h6>} />
                <StatusTextFieldAdminAccess className="px-3" record={{ ...props }} source="access.admin" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Admin Access </h6>} />
                <StatusTextField source="disabled" className="px-3" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Disabled </h6>} />
            </Datagrid>
        </List>
    </>
);

export default UserList;
